import '@spectrum-web-components/icons-workflow/icons/sp-icon-building.js';
import '@spectrum-web-components/icons-workflow/icons/sp-icon-cclibrary.js';
import '@spectrum-web-components/icons-workflow/icons/sp-icon-chevron-down.js';
import '@spectrum-web-components/icons-workflow/icons/sp-icon-chevron-right.js';
import '@spectrum-web-components/icons-workflow/icons/sp-icon-edit.js';
import '@spectrum-web-components/icons-workflow/icons/sp-icon-flag.js';
import '@spectrum-web-components/icons-workflow/icons/sp-icon-globe-grid.js';
import '@spectrum-web-components/icons-workflow/icons/sp-icon-link-out-light.js';
import '@spectrum-web-components/icons-workflow/icons/sp-icon-share.js';
import '@spectrum-web-components/icons-workflow/icons/sp-icon-user-group.js';

import '@adobe-fonts/site/components/display-in-font/DisplayInFont.js';
import '@adobe-fonts/site/components/libraries/follow-library-button/FollowLibraryButton.js';
import '@adobe-fonts/site/components/libraries/library-card-list/LibraryCardList.js';
import '@adobe-fonts/site/components/libraries/report-abuse-button/ReportAbuseButton.js';
import '@adobe-fonts/site/components/settings-bar/font-size-slider/FontSizeSlider.js';
import '@adobe-fonts/site/components/settings-bar/font-sorter/FontSorter.js';
import '@adobe-fonts/site/components/settings-bar/sample-text-menu/SampleTextMenu.js';
import '@adobe-fonts/site/components/settings-bar/view-options/ViewOptions.js';

import '../components/LibrariesIndexPage.js';
import '../components/LibrariesPageLoader.js';
import '../components/LibraryShowPage.js';

void import('@adobe-fonts/site/components/libraries/delete-library-dialog/DeleteLibraryDialog.js');
void import('@adobe-fonts/site/components/libraries/edit-library-dialog/EditLibraryDialog.js');
void import('@adobe-fonts/site/components/libraries/library-actions-menu/LibraryActionsMenu.js');
void import('@adobe-fonts/site/components/libraries/libraries-toolbar/LibrariesToolbar.js');
void import('@adobe-fonts/site/components/libraries/new-library-dialog/NewLibraryDialog.js');
void import('@adobe-fonts/site/components/libraries/share-library-dialog/ShareLibraryDialog.js');
